import { NavBar } from "./components/NavBar";
import { Signin } from "./pages/Signin";
import { Books } from "./pages/Books";
import { BooksId } from "./pages/BooksId";
import { KeypointId } from "./pages/KeypointId";
import { Home } from "./pages/Home";
import { Signup } from "./pages/Signup";
import { Navigate, Route, Routes } from "react-router-dom";
import { SearchPage } from "./pages/SearchPage";
import { onAuthStateChanged } from "firebase/auth";
import { useEffect, useState } from "react";
import { auth } from "./config/firebase";

function App() {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      try {
        if (user) {
          setCurrentUser(user);
          localStorage.setItem("uid", user.uid);
        } else {
          setCurrentUser(null);
          localStorage.removeItem("uid");
        }
      } catch (error) {
        console.error("Error fetching user additional data:", error);
      }
    });
  }, [currentUser]);

  const storedUid = localStorage.getItem("uid");

  return (
    <>
      <NavBar />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route
          path="/books"
          element={
            currentUser || storedUid ? (
              <Books />
            ) : (
              <Navigate replace to={"/signin"} />
            )
          }
        />
        <Route
          path="/books/:id"
          element={
            currentUser || storedUid ? (
              <BooksId />
            ) : (
              <Navigate replace to={"/signin"} />
            )
          }
        />
        <Route
          path={`/books/:id/:keypointId`}
          element={
            currentUser || storedUid ? (
              <KeypointId />
            ) : (
              <Navigate replace to={"/signin"} />
            )
          }
        />
        <Route path="/signup" element={<Signup />} />
        <Route path="/signin" element={<Signin />} />
        <Route
          path="/search"
          element={
            currentUser || storedUid ? (
              <SearchPage />
            ) : (
              <Navigate replace to={"/signin"} />
            )
          }
        />
        <Route path="*" element={"<NotFound />"} />
      </Routes>
    </>
  );
}

export default App;
